var _a, _b;
import AccoutCheckService from "../api/AccoutCheckService";
export var EHanleType;
(function (EHanleType) {
    EHanleType[EHanleType["Submit"] = 1] = "Submit";
    EHanleType[EHanleType["Confirm"] = 2] = "Confirm";
    EHanleType[EHanleType["Delete"] = 3] = "Delete";
})(EHanleType || (EHanleType = {}));
var service = AccoutCheckService.getInstance();
var handleDict = (_a = {},
    _a[EHanleType.Submit] = service.submit,
    _a[EHanleType.Delete] = service.deleteOrder,
    _a[EHanleType.Confirm] = service.confirm,
    _a);
var msgDict = (_b = {},
    _b[EHanleType.Submit] = "提交后将不可更改，是否继续？",
    _b[EHanleType.Delete] = "废弃后将不可撤消，是否继续？",
    _b[EHanleType.Confirm] = "确认后将不可修改，是否继续？",
    _b);
export function handle(type, context, params, hideConfirm) {
    if (hideConfirm === void 0) { hideConfirm = false; }
    var promise;
    var confirmPromise = hideConfirm ? Promise.resolve() : context.$confirm(msgDict[type], '提示');
    switch (type) {
        case EHanleType.Confirm:
        case EHanleType.Delete:
            promise = confirmPromise.then(function () { return simpleSubmit(handleDict[type], context, params); });
            break;
        case EHanleType.Submit:
            promise = confirmPromise.then(function () { return submit(handleDict[type], context, params, null, null); });
            break;
        default:
            promise = Promise.resolve("ok");
            break;
    }
    return promise;
}
function submit(serviceHandle, context, params, money_confirm, upload_confirm, is_delete_other_list) {
    if (is_delete_other_list === void 0) { is_delete_other_list = null; }
    var nextActionFlag = 1;
    var resultParams = { order_id: params };
    if (money_confirm && money_confirm == 1) {
        resultParams = Object.assign(resultParams, { money_confirm: 1 });
    }
    if (upload_confirm && upload_confirm == 1) {
        resultParams = Object.assign(resultParams, { upload_confirm: 1 });
    }
    if (is_delete_other_list && is_delete_other_list == 1) {
        resultParams = Object.assign(resultParams, { is_delete_other_list: 1 });
    }
    return serviceHandle(resultParams).then(function (res) {
        console.log('========', res.data.code);
        if (res.data.code === 65) {
            context.$confirm('该对账单存在反审核已废弃的对账明细，该明细单据将默认删除，是否确认？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                submit(serviceHandle, context, params, money_confirm, upload_confirm, 1);
            }).catch(function () {
            });
            return;
        }
        else if (res.data.code == 76) {
            context.$message.error(res.data.msg);
            context.getList();
            return;
        }
        else if (res.data.code == 64) {
            context.$confirm('<div style="max-height: 80vh; overflow: scroll">'
                + res.data.msg + '<br><br>'
                + res.data.data.reduce(function (pre, item) { return pre + item.name + '<br>' + item.infos.join(', ') + '<br><br>'; }, '')
                + '</div>', '提示', {
                dangerouslyUseHTMLString: true,
                showCancelButton: false,
                confirmButtonText: '知道了'
            });
            context.getList();
            return;
        }
        else if (res.data.code == 80) {
            context.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
            });
        }
        else if (res.data.code == 78) {
            context.$confirm(res.data.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                submit(serviceHandle, context, params, 1, null, is_delete_other_list);
            }).catch(function () {
            });
        }
        else if (res.data.code == 79) {
            context.$confirm(res.data.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                submit(serviceHandle, context, params, null, 1, is_delete_other_list);
            }).catch(function () {
            });
        }
        else if (res.data.code == 0) {
            context.$message.success(res.data.msg);
            context.getList();
        }
    }, function (err) {
        if (err.resData && err.resData.flag === nextActionFlag) {
            context.$confirm(err.resData.msg, {
                confirmButtonText: "废弃"
            }).then(function (res) {
                handle(EHanleType.Delete, context, err.resData.data, true);
            });
        }
        else if (err.msg || err.message) {
            context.$message.error(err.msg || err.message);
        }
    });
}
function simpleSubmit(serviceHandle, context, params) {
    return serviceHandle(params).then(function (res) {
        if (res.data.code == 76) {
            context.$message.error(res.data.msg);
        }
        else {
            context.$message.success(res.data.msg);
        }
        context.getList();
    }, function (err) {
        if (err.msg || err.message) {
            context.$message.error(err.msg || err.message);
        }
    });
}
